import { render, staticRenderFns } from "./cloud-storage-usage.component.vue?vue&type=template&id=04fbf512&scoped=true&"
import script from "./cloud-storage-usage.component.vue?vue&type=script&lang=js&"
export * from "./cloud-storage-usage.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fbf512",
  null
  
)

export default component.exports